"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrimSchema = void 0;
const yup = __importStar(require("yup"));
const tra = __importStar(require("../attributes/trimAttributes"));
const shared = __importStar(require("./sharedSchemas"));
const types_1 = require("../types");
const utils_1 = require("./utils");
exports.TrimSchema = yup
    .object({
    productType: shared.productTypeSchema(types_1.ProductTypes.Trim),
    sellingUnit: utils_1.reqSelectOneSchema(Object.values(tra.SellingUnit)),
    widthIn: yup
        .number()
        .positive()
        .transform(utils_1.NaNtoUndefined)
        .test(utils_1.decimalsTest(6))
        .max(100)
        .required(),
    lengthM: shared.widthLengthBaseSchema.max(200).required(),
    trimLengthType: utils_1.reqSelectOneSchema(Object.values(tra.KnownOrEstimated)),
    trimType: shared.titleSetLargeSchema.required(),
    weaveType: yup
        .array(shared.titleSetLargeSchema)
        .default([])
        .max(1)
        .optional(),
    qualities: yup
        .array(shared.titleSetLargeSchema)
        .default([])
        .max(3)
        .optional(),
    shape: shared.titleSetLargeSchema.optional(),
    trimContent: yup
        .array(shared.titleSetLargeSchema.required())
        .min(1)
        .max(2)
        .required(),
    design: shared.sentenceSetSchema.optional(),
    packSize: shared.packSizeSchema,
    colour: shared.colourSchema,
    colourTone: shared.colourToneSchema,
    uses: shared.usesSchema.max(3),
    imperfections: shared.imperfectionsSchema.transform((val) => {
        if (val[0] instanceof Array)
            return val[0];
        return val;
    }),
    quantity: shared.quantitySchema.required(),
    price: shared.priceSchema
})
    .when('$product.sellingUnit', (sellingUnit, schema) => {
    switch (sellingUnit) {
        case tra.SellingUnit['By Meter']:
            return schema.omit(['lengthM', 'trimLengthType', 'packSize']);
        case tra.SellingUnit['Bundle']:
            return schema.omit(['trimLengthType', 'packSize']);
        case tra.SellingUnit.Roll:
            return schema.omit(['packSize']);
        case tra.SellingUnit.Pack:
            return schema.omit(['trimLengthType']);
        default:
            return schema;
    }
})
    .test('Context Check', "Product Validator needs product in it's context", (_, context) => {
    var _a;
    if (!((_a = context.options.context) === null || _a === void 0 ? void 0 : _a.product))
        return false;
    return true;
})
    .required();
//# sourceMappingURL=trimSchema.js.map